import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";
import SidebarNavMenu from "../../components/SidebarNavMenu";

import {ReactComponent as BoxIcon} from "assets/img/box-2.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {getStockEasyLink} from "domain/helpers/StockEasyHelper";

import {SidebarContext} from "../../../../../../SidebarContext";

function EikowProductsItem(props) {
    const {currentPath, currentMemberAuthorizations, currentMember} = useContext(SidebarContext);

    if (!currentMember?.retailers || !hasAuthorization(currentMemberAuthorizations, Authorizations.STOCK_EASY_ACCESS)) {
        return null;
    }

    const isInStockEasyPath = currentPath.startsWith(MarketplaceRoutes.STOCK_EASY);
    
    return (
        <SidebarNavMenu
            open={isInStockEasyPath}
            icon={<BoxIcon />}
            content={<FormattedMessage id='sidebar.item.eikow' />}
        >
            {currentMember.retailers.map((retailer) => {
                const isInStockEasyRetailerPath =
                    currentPath.startsWith(MarketplaceRoutes.STOCK_EASY_SHOW_RETAILER(retailer.id))
                    || currentPath.startsWith(MarketplaceRoutes.STOCK_EASY_RETAILER(retailer.id))
                ;

                return (
                    <SidebarItem
                        key={retailer.id}
                        to={getStockEasyLink(retailer.id)}
                        selected={isInStockEasyRetailerPath}
                    >
                        {retailer.name}
                    </SidebarItem>
                )
            })}
        </SidebarNavMenu>
    );
}

export default EikowProductsItem;
